<div class="d-flex flex-column justify-content-start align-items-stretch h-100 w-100 my-3">

    <app-spinner [isLoading]="isLoadingData" [isFullScreen]="false"></app-spinner>

    <div *ngIf="!isLoadingData" class="container-fluid p-4">

        <p-message
            styleClass="w-100"
            *ngIf="loadingMessage.show"
            [severity]="loadingMessage.severity"
            [text]="loadingMessage.text">
        </p-message>

        <div *ngIf="editions && students && knowns">

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">
                <span class="text-primary-color fw-bolder">{{labels.studentSelectorLabel}}</span>
                <app-student-selector
                    class="w-100"
                    [students]="students"
                    [(selected)]="enrollment.student"
                    (selectedChange)="onEnrollmentChange()">
                </app-student-selector>
            </div>

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">
                <span class="text-primary-color fw-bolder">{{labels.editionSelectorLabel}}</span>
                <app-edition-selector
                    class="w-100"
                    [editions]="editions"
                    [(selected)]="enrollment.edition"
                    (selectedChange)="onEnrollmentChange()">
                </app-edition-selector>
            </div>

            <div class="d-flex flex-column justify-content-center align-items-start w-100 mb-4">
                <span class="text-primary-color fw-bolder">{{labels.knownSelectorLabel}}</span>
                <app-known-selector
                    class="w-100"
                    [knowns]="knowns"
                    [(selected)]="enrollment.known"
                    (selectedChange)="onEnrollmentChange()">
                </app-known-selector>
            </div>

        </div>

    </div>

</div>
